import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LightModal } from '@repo/ui/components/Modal/LightModal';
import { PRIVACY_POLICY_TEXT } from '../components/login/policyConstants';

export const Route = createFileRoute('/privacy-policy')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <LightModal
        isOpen={true}
        title="Privacy Policy for Cloud App"
        onClose={() => navigate({ to: '/login' })}
        className="max-w-4xl"
      >
        <div className="prose prose-sm max-w-none">{PRIVACY_POLICY_TEXT}</div>
      </LightModal>
    </div>
  );
}
